module.exports = __webpack_public_path__ + "img/fund-home-2.92f4e13b.png";